/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Pro_TitleInputs */

const en_directory_submit_review_pro_title = /** @type {(inputs: Directory_Submit_Review_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const zh_directory_submit_review_pro_title = /** @type {(inputs: Directory_Submit_Review_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Directory_Submit_Review_Pro_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_pro_title = /** @type {((inputs?: Directory_Submit_Review_Pro_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Pro_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_pro_title(inputs)
	return zh_directory_submit_review_pro_title(inputs)
});
export { directory_submit_review_pro_title as "directory.submit.review.pro_title" }